"use client";

// Root-level error boundary — only fires if the root layout itself (or a page
// outside the (app) shell, e.g. login/forgot-password) throws. Must render its
// own <html>/<body> since it replaces the root layout when active.

export default function GlobalError({
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html lang="en">
      <body style={{ display: "flex", minHeight: "100dvh", alignItems: "center", justifyContent: "center", fontFamily: "system-ui, sans-serif" }}>
        <div style={{ textAlign: "center" }}>
          <p style={{ fontSize: 18, fontWeight: 600 }}>Bell System hit an unexpected error</p>
          <p style={{ fontSize: 13, color: "#888", marginTop: 4 }}>
            Try again, or reload the page if this keeps happening.
          </p>
          <button
            onClick={() => reset()}
            style={{
              marginTop: 16,
              height: 40,
              padding: "0 16px",
              borderRadius: 10,
              border: "1px solid #ccc",
              background: "transparent",
              cursor: "pointer",
              fontSize: 13,
            }}
          >
            Try again
          </button>
        </div>
      </body>
    </html>
  );
}
